<template>
	<div id="shangx">

		<div class="fflex ffbet">
			<ul class="fflex headBox">
				<li @click="jump('shanglei')">商品类型</li>
				<li @click="jump('gongys')">供应商</li>
				<li class="active">商品信息</li>
				<li @click="jump('wuliu')">物流设置</li>
				<li @click="jump('churukl')">出入库类型</li>
				<li @click="jump('rizhi')">日志列表</li>
			</ul>
		</div>

		<div class="fflex ffbet" style="margin: 10px 0;line-height: 32px;color: #999;align-items: center">
			<div>
				<span>商品类型：</span>
				<select name="" class="xiala " v-model="goods" style="width: 120px;margin-right: 10px;margin-left: 5px">
					<option value="">请选择</option>
					<option :value="goodtype.id" v-for="goodtype in good_types">{{goodtype.type_name}}</option>

				</select>

				<span>供应商：</span>
				<select name="" class="xiala " v-model="gys" style="width: 120px;margin-right: 10px;margin-left: 5px">
					<option value="">请选择</option>
					<option v-for="su in suppliers" :value="su.id">{{su.supplier_name}}</option>

				</select>
				<span>商品名称：</span>
				<input type="text" class="xiala" placeholder="商品名称查询" v-model="shangname" @keyup.enter="chaxun" style="width: 120px;margin-right: 10px;margin-left: 5px">
				<el-button type="warning" size="mini" @click="chaxun">查询</el-button>
			</div>


			<el-button type="warning" round size="mini" class="purBtnsz" @click="tan(1)" style="height: 26px;">添加商品
			</el-button>

		</div>

		<div class="tableBox">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th>序号</th>
						<th>商品编号</th>
						<th>商品名称</th>
						<th>商品类别</th>
						<th>规格</th>
						<th>单位</th>
						<th>商品图片</th>
						<th>成本价</th>
						<th>采购价</th>
						<th>销售价</th>
<!--						<th>积分兑换</th>-->
						<th>操作</th>


					</tr>
				</thead>
				<tbody>
					<tr v-for="(ta,taindex) in tabledata" :key="taindex">
						<td>{{taindex+1}}</td>
						<td>
							{{ta.good_num}}
						</td>
						<td>{{ta.good_name}}</td>
						<td>{{ta.type_name}}</td>

						<td>{{ta.spec}}</td>

						<td>{{ta.unit}}</td>
						<td><img style="width: 25px;height: 25px" :preview="taindex" :src="ta.imgpath" alt=""></td>
						<td>{{ta.cost_price}}</td>
						<td>{{ta.purchase_price}}</td>
						<td>{{ta.real_price}}</td>
<!--						<td>{{ta['is_exchange'] == 1 ? '不可兑换' : ta['exchange_integral']}}</td>-->
						<td>
							<span class="tablebtnBox">
								<div class="qianziBtn-mini" style="    background: rgb(0, 204, 228);color: #fff" @click="tan(2,ta.id)">查看</div>
								<div class="shenziBtn-mini" @click="tan(3,ta.id)">修改</div>
								<div class="qianziBtn-mini" @click="delfn(ta.id)" style="    background: rgb(255, 121, 124);color: #fff">删除</div>
							</span>
						</td>

					</tr>
					<tr v-if="tabledata==''">
						<td colspan="11" align="center">暂无数据</td>
					</tr>
				</tbody>
			</table>
			<p>共有4条记录 当前1页/共1页</p>
		</div>

		<div class="table-bottom">
			<div>
				<el-pagination @current-change="handleCurrentChange" :current-page="currentpage" :page-size="pageone" background
				 layout="prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>

		<el-dialog class="tanchuang" :title="Ttitle" :visible.sync="shangxt" width="650px">
			<form id="art_form" action="#" method="post" enctype="multipart/form-data">
				<el-row>
					<el-col :span="12" class="marBo2">
						<div class="demo-input-suffix">
							<span class="inputT" style="color: red"><span>*</span>商品编号：</span>
							<el-input style="width: 200px" placeholder="自动生成" :disabled="true" size="small" v-model="good_num">
							</el-input>
						</div>

					</el-col>
					<el-col :span="12" class="marBo2">
						<span class="inputT" style="color: red"><span>*</span>商品名称：</span>
						<el-input style="width: 200px" placeholder="商品名称" :disabled="dis" size="small" v-model="good_name" name="good_name">
						</el-input>
					</el-col>
					<el-col :span="12" class="marBo2">
						<span class="inputT" style="color: red"><span>*</span>采购价格：</span>
						<el-input style="width: 200px" :disabled="dis" size="small" name="purchase_price" v-model="purchase_price">
						</el-input>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT" style="color: red"><span>*</span>销售价格：</span>
						<el-input style="width: 200px" :disabled="dis" size="small" v-model="real_price" name="real_price">
						</el-input>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">成本价格：</span>
						<el-input style="width: 200px" v-model="cost_price" :disabled="dis" size="small" name="cost_price">
						</el-input>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">商品类型：</span>
						<select name="type_id" v-model="type_id" class="xiala " :disabled="dis">
							<option value="">请选择</option>
							<option :value="goodtype.id" v-for="goodtype in good_types">{{goodtype.type_name}}</option>
						</select>

					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">商品规格：</span>
						<el-input style="width: 200px" placeholder="商品的体积、大小" :disabled="dis" size="small" name="spec" v-model="spec">
						</el-input>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">供应商：</span>
						<select name="supplier_id" v-model="supplier_id" class="xiala " :disabled="dis">
							<option value="">请选择</option>
							<option v-for="su in suppliers" :value="su.id">{{su.supplier_name}}</option>
						</select>
					</el-col>


					<el-col :span="12" class="marBo2">
						<span class="inputT">商品型号：</span>
						<el-input style="width: 200px" name="model" :disabled="dis" size="small" v-model="model">
						</el-input>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">商品重量：</span>
						<el-input style="width: 200px" name="weight" v-model="weight" :disabled="dis" size="small">
						</el-input>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">计量单位：</span>
						<el-input name="unit" style="width: 200px" placeholder="m" :disabled="dis" size="small" v-model="unit">
						</el-input>
					</el-col>
<!--          <el-col :span="12" class="marBo2" style="height: 28px;margin-top: 4px;">-->
<!--              <span class="inputT">积分兑换：</span>-->
<!--              <el-radio v-model="is_exchange" name="is_exchange" :disabled="dis" :label="2">是</el-radio>-->
<!--              <el-radio v-model="is_exchange" name="is_exchange" :disabled="dis" :label="1">否</el-radio>-->
<!--          </el-col>-->
					<el-col :span="12" class="marBo2" v-if="!dis">
						<span class="inputT">上传商品图片：</span>
						<el-button type="warning" size="small" @click="upimg">选择图片</el-button>
						<input size="100" type="file" name="image" id="img_upload" @change="fn($event)" style="display: none" accept="image/*">
					</el-col>
					<el-col :span="12" class="marBo2" v-show="is_exchange == 2">
						<span class="inputT">积分价格：</span>
						<el-input name="exchange_integral" style="width: 200px" :disabled="dis" size="small" v-model="exchange_integral">
						</el-input>
					</el-col>
					<el-col :span="24" >
						<span class="inputT">预览图片：</span>
						<img :src="ylimg" class="yulantu">
						<input type="hidden" v-model="imgpath" name="imgpath">
						<input type="hidden" v-model="mini_imgpath" name="mini_imgpath">
						<!--imgpath-->
					</el-col>

					<el-col :span="24" class="marBo2">
						<span class="inputT" style="padding-bottom: 10px"> 备注：</span>
						<el-input :disabled="dis" type="textarea" :autosize="{ minRows: 2}" name="notes" v-model="notes">
						</el-input>
						<input type="hidden" v-if="id" v-model="id" name="id">
						<input type="hidden" v-model="token" name="token">
					</el-col>
					<el-col :span="24" v-if="zhuang==3" style="text-align: center">
						<el-button type="warning" round size="mini" class="purBtnsz" @click="xiugai">确认修改</el-button>
					</el-col>

					<el-col :span="24" v-if="zhuang==1" style="text-align: center">
						<el-button type="warning" round size="mini" class="purBtnsz" @click="tianj">确认添加</el-button>
					</el-col>

				</el-row>
			</form>
		</el-dialog>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				token: '',
				gyshang: '',
				currentpage: 1,
				pageone: 10,
				total: 100,
				shangxt: false,
				zhuang: '',
				Ttitle: '',
				dis: false,
				//            shangphone:''
				goodsleiop: [{
					value: '',
					label: '请选择'
				}, {
					value: '195',
					label: '非消耗品'
				}, {
					value: '196',
					label: '日常消耗品'
				}, {
					value: '197',
					label: '固定资产'
				}],
				goodslei: '',
				ylimg: 'https://saas.gymbaby.cn/static/qmsj/img/jinxiaocun/default2.jpg',
				imgbox: [],
				tabledata: '',
				suppliers: '',
				good_types: '',

				goods: '',
				gys: '',
				shangname: '',
				good_name: '',
				purchase_price: '',
				imgpath: '',
				mini_imgpath: '',
				good_num: '',
				real_price: '',
				cost_price: '',
				type_id: '',
				spec: '',
				supplier_id: '',
				model: '',
				weight: '',
				notes: '',
				unit: '',
				id: '',
				is_exchange:1,
				exchange_integral:0,

			};
		},
		methods: {
			gonggong: function() {
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/JxcGoods/index',
					type: 'post',
					data: {
						token: self.token,
						page: self.currentpage,
						typeid: self.goods,
						supplierid: self.gys,
						search: self.shangname
					},
					dataType: 'json',
					success: function(data) {
						self.good_types = data.good_types
						self.suppliers = data.suppliers
						if (data.status == 1) {
							self.tabledata = data.data;
							self.total = Number(data.map.count);
						} else {
							self.tabledata = '';
							self.total = 0;
						}

					}

				})

			},
			chaxun: function() {
				let self = this;
				self.currentpage = 1;
				self.gonggong()

			},
			upimg: function() {
				let self = this;
				$('#img_upload').click()


			},
			fn: function(e) {
				//this.filebox.push(e.currentTarget.files);

				//ss
				var imgPath = $("#img_upload").val();

				var formData = new FormData($('#art_form')[0]);
				let self = this

				$.ajax({
					type: "POST",
					url: process.env.apiUrl + "saas/JxcGoods/imgupload",
					data: formData,
					contentType: false,
					processData: false,
					dataType: 'json',
					success: function(data) {

						if (data.status == 1) {
							self.imgpath = data.imgpath;
							self.mini_imgpath = data.mini_imgpath;
							self.ylimg = data.imgpath;

						}
					},
					error: function(XMLHttpRequest, textStatus, errorThrown) {
						alert("上传失败，请检查网络后重试");
					}
				});
			},
			tan: function(e, id) {
				let self = this;
				this.zhuang = e;
				if (this.zhuang == 1) {
					let self = this;
					self.Ttitle = '添加商品'
					self.dis = false;
					self.good_num = ''
					self.good_name = '';
					self.purchase_price = '';
					self.real_price = '';
					self.cost_price = '';
					self.type_id = '';
					self.spec = '';
					self.supplier_id = '';
					self.model = '';
					self.weight = '';
					self.notes = '';
					self.ylimg = '';
					self.is_exchange = 1;
					self.exchange_integral = 0;

				} else if (this.zhuang == 2) {
					this.Ttitle = '查看商品'
					this.dis = true;
					this.id = id;

					$.ajax({
						type: "POST",
						url: process.env.apiUrl + "saas/JxcGoods/edit",
						data: {
							token: self.token,
							id: id
						},
						dataType: 'json',
						success: function(data) {
							self.good_num = data.data.good_num;
							self.good_name = data.data.good_name;
							self.purchase_price = data.data.purchase_price;
							self.real_price = data.data.real_price;
							self.cost_price = data.data.cost_price;
							self.type_id = data.data.type_id;
							self.spec = data.data.spec;
							self.supplier_id = data.data.supplier_id;
							self.model = data.data.model;
							self.weight = data.data.weight;
							self.notes = data.data.notes;
							self.ylimg = data.data.imgpath;
                            self.is_exchange = data.data.is_exchange;
                            self.exchange_integral = data.data.exchange_integral;

						},
						error: function(XMLHttpRequest, textStatus, errorThrown) {
							alert("查看详情失败");
						}
					});


				} else {
					this.Ttitle = '修改商品'
					this.dis = false;
					this.id = id;
					$.ajax({
						type: "POST",
						url: process.env.apiUrl + "saas/JxcGoods/edit",
						data: {
							token: self.token,
							id: id
						},
						dataType: 'json',
						success: function(data) {
							self.good_num = data.data.good_num;
							self.good_name = data.data.good_name;
							self.purchase_price = data.data.purchase_price;
							self.real_price = data.data.real_price;
							self.cost_price = data.data.cost_price;
							self.type_id = data.data.type_id;
							self.spec = data.data.spec;
							self.supplier_id = data.data.supplier_id;
							self.model = data.data.model;
							self.weight = data.data.weight;
							self.notes = data.data.notes;
							self.ylimg = data.data.imgpath;
                            self.is_exchange = data.data.is_exchange;
                            self.exchange_integral = data.data.exchange_integral;
						}

					});


				}
				this.shangxt = true;
			},
			handleCurrentChange: function(i) {
				let self = this;
				self.currentpage = i;
				self.gonggong();
			},

			jump: function(e) {
				this.$router.push({
					'name': e
				})
			},
			xiugai: function() {
				let self = this;

				var formData = new FormData($('#art_form')[0]);
				$.ajax({
					type: "POST",
					url: process.env.apiUrl + "saas/JxcGoods/update",
					data: formData,
					contentType: false,
					processData: false,
					dataType: 'json',
					success: function(data) {
						if (data.status == 1) {

							self.$message({
								type: 'success',
								message: data.msg
							});
							self.shangxt = false;
							self.good_num = '';
							self.good_name = '';
							self.purchase_price = '';
							self.real_price = '';
							self.cost_price = '';
							self.type_id = '';
							self.spec = '';
							self.supplier_id = '';
							self.model = '';
							self.weight = '';
							self.notes = '';
							self.unit = '';
							self.ylimg = '';
                            self.is_exchange = 1;
                            self.exchange_integral = 0;
							self.gonggong()
						} else {
							self.$message({
								type: 'error',
								message: data.msg
							});
						}
					},
					error: function(XMLHttpRequest, textStatus, errorThrown) {
						alert("修改失败，请检查网络后重试");
					}
				});


			},
			tianj: function() {
				let self = this;

				var formData = new FormData($('#art_form')[0]);
				$.ajax({
					type: "POST",
					url: process.env.apiUrl + "saas/JxcGoods/store",
					data: formData,
					contentType: false,
					processData: false,
					dataType: 'json',
					success: function(data) {
						if (data.status == 1) {

							self.$message({
								type: 'success',
								message: data.msg
							});
							self.shangxt = false;
							self.good_num = '';
							self.good_name = '';
							self.purchase_price = '';
							self.real_price = '';
							self.cost_price = '';
							self.type_id = '';
							self.spec = '';
							self.supplier_id = '';
							self.model = '';
							self.weight = '';
							self.notes = '';
							self.unit = '';
							self.ylimg = '';
                            self.is_exchange = 1;
                            self.exchange_integral = 0;
							self.gonggong()
						} else {
							self.$message({
								type: 'error',
								message: data.msg
							});
						}
					},
					error: function(XMLHttpRequest, textStatus, errorThrown) {
						alert("上传失败，请检查网络后重试");
					}
				});


				//            if(/^[0-9]{1,4}-[0-9]{1,8}$/.test(self.shangphone) ){
				//                alert('格式正确！')
				//            }else{
				//                alert('格式不对！')
				//            }
			},
			delfn: function(id) {
				let self = this;
				this.$confirm('此操作将删除该商品, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					//这里请求ajax
					$.ajax({
						url: process.env.apiUrl + 'saas/JxcGoods/delete',
						type: 'post',
						data: {
							token: self.token,
							id: id
						},
						dataType: 'json',
						success: function(data) {
							if (data.status == 1) {
								self.$message({
									type: 'success',
									message: '删除成功!'
								});
								self.gonggong()
							} else {
								self.$message({
									type: 'error',
									message: '删除失败!'
								});
							}
						}
					})
				}).catch(() => {
					//                this.$message({
					//                    type: 'info',
					//                    message: '已取消删除'
					//                });
				});
			}

		},
		mounted: function() {
			var self = this;
			self.token = $.cookie('token');

			$.ajax({
				url: process.env.apiUrl + 'saas/JxcGoods/index',
				type: 'post',
				data: {
					token: self.token
				},
				dataType: 'json',
				success: function(data) {
					if (data.status == 1) {
						self.tabledata = data.data;
						self.total = Number(data.map.count);
					} else {
						self.tabledata = '';
						self.total = 0;
					}
                    self.suppliers = data.suppliers
                    self.good_types = data.good_types
				}

			})


		}


	}
</script>

<style scoped>
	.xiala {
		width: 200px;
		height: 32px;
		line-height: 32px;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: 13px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

	}

	.tablebtnBox div{
		cursor: pointer;
	}

	.yulantu {
		width: 100px;
		height: 100px;
		border-radius: 6px;
		margin-left: 10px;
	}

	ul {
		list-style: none;
	}

	#shangx p,
	label,
	ul {
		margin: 0;
		padding: 0;
	}

	.fflex {
		display: flex;
		display: -webkit-flex;
	}

	.fflex li{
		cursor: pointer;
	}

	.ffbet {
		justify-content: space-between;
	}

	.ffend {
		justify-content: flex-end;
	}

	#shangx * {
		box-sizing: border-box;
	}

	#shangx {
		box-sizing: border-box;
		padding: 10px;
	}

	.headBox li {
		width: 75px;
		background: #E6BE8A;
		height: 30px;
		line-height: 30px;
		margin-right: 8px;
		border-radius: 5px 5px 0 0;
		text-align: center;
		color: #fff;

	}

	.headBox li.active {
		background: #ecebfd;
		color: #E6BE8A;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
	}

	.purBtnsz {
		background: #E6BE8A !important;
		height: 26px;

		border: none !important;
	}

	.marBo2 {
		margin-bottom: 10px;
	}

	.inputT {
		display: inline-block;
		width: 100px;

	}
</style>
<style>


</style>



// WEBPACK FOOTER //
// src/pages/jinxc/shangx.vue